export default "__VITE_PUBLIC_ASSET__3d6491c0__"